import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-canvas py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-100" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-101" data-mp="9tl6ys2559ro">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-navy-100 bg-white p-8 shadow-sm sm:p-12" data-id="element-102" data-mp="et67h6wylq6i">
          <span className="inline-flex rounded-full bg-leaf-50 p-4 text-leaf-600" data-id="element-103" data-mp="skcd7kqu0k1u">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-104" data-mp="xjnviy6ujxlj" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-navy-900" data-id="element-105" data-mp="12j0gtei2kwm0">
            Garantía total de 7 días
          </h2>
          <p className="mt-4 leading-relaxed text-navy-700" data-id="element-106" data-mp="17j6bl3jmyz8b">
            Abre los 9 tomos. Revisa los 5 bonos. Úsalos en tu clase más difícil esta semana. Si sientes que tus alumnos
            no respondieron mejor, o que el material no te ahorró horas de trabajo:
          </p>
          <p className="mt-6 rounded-lg bg-navy-900 px-5 py-4 text-lg font-extrabold text-white" data-id="element-107" data-mp="1vt7r6uhtr9iq">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios. Sin complicaciones.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-navy-700" data-id="element-108" data-mp="2oioi1npsqicu">
            Porque si el material no te da el valor que prometemos, no queremos quedarnos con tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}